import styled from 'styled-components';

export const TUTDContainer = styled.div`
  margin-top: 3rem;
`;
